import { Pipe, PipeTransform } from '@angular/core';
import { formatOptions } from '@util/format-options';
import { SelectItem } from 'primeng/api';

@Pipe({
  name: 'dropdownOptions'
})
export class DropdownOptionsPipe implements PipeTransform {
  transform(values: any[], gid?: boolean): SelectItem[] {
    return formatOptions(values, gid);
  }
}
